import React, { useEffect, useState } from "react";
import {
  useMarkAsSingle,
  useSendToDispatch,
  useSubscriptionOrder,
  useDownloadInternationalPrescription,
} from "./store";
import { Button } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import InternationalPrescription from "./InternationalPrescription";

function ConfirmationPrompt({
  btn,
  name,
  note,
  orderId,
  setForm,
  question,
  setTrigger,
  customerId,
  setRequest,
  subscription,
  isOrderSingle,
  setOrderSingle,
  setSubscription,
}) {
  const [userPrescription, setUserPrescription] = useState();
  const [isPrint, setIsPrint] = useState(false);
  const { downloadInternationalPrescription, prescriptionData } =
    useDownloadInternationalPrescription();
  const { setToaster } = useToast();
  const { markAsSingle } = useMarkAsSingle();
  const { subscriptionOrder } = useSubscriptionOrder();
  const sendRequest = (request) => {
    switch (request) {
      case "as single order":
        markAsSingle(orderId, isOrderSingle ? false : true, setToaster);
        setOrderSingle(isOrderSingle ? false : true);
        break;
      case "as subscription order":
        subscriptionOrder(orderId, subscription ? "false" : "true", setToaster);
        setSubscription(subscription ? false : true);
        break;
      case "Resync Order":
        break;
    }
  };
  useEffect(() => {
    !isPrint && setUserPrescription(null);
  }, [isPrint]);

  useEffect(() => {
    setIsPrint(false);
  }, [orderId]);

  useEffect(() => {
    setUserPrescription(prescriptionData);
  }, [prescriptionData]);

  useEffect(() => {
    setTimeout(() => {
      setForm(name);
      setTrigger(["hover", "focus"]);
    }, 5000);
  }, []);

  return (
    <div>
      <p className="text-center">
        <span>{question}</span>
        {note && <span className="text-warning">{note}</span>}
      </p>
      <div className="d-flex justify-content-around">
        <Button
          size="sm"
          className="btn btn-success mb-1 mx-1"
          onClick={() => {
            if (name === "Download Prescription") {
              downloadInternationalPrescription(
                customerId,
                orderId,
                setToaster,
                setIsPrint
              );
            } else {
              setForm(name);
              setTrigger(["hover", "focus"]);
            }
          }}
        >
          {name === "Download Prescription" ? "International" : "Cancel"}
        </Button>
        <Button
          size="sm"
          className="btn btn-warning mb-1 me-1"
          onClick={() => {
            if (name === "Download Prescription") {
              const url = `https://form.traya.health/prescription?userId=${customerId}&orderId=${orderId}`;
              window.open(url, "_blank");
            } else if (name === "as single order") {
              setOrderSingle(!isOrderSingle);
            } else if (name === "as subscription order") {
              setSubscription(!subscription);
            } else if (name === "Send To Dispatch") {
              btn(false);
            } else if (setRequest) {
              setRequest(true);
            }
            sendRequest(name);
            setForm(name);
            setTrigger(["hover", "focus"]);
          }}
          object
        >
          {name === "Download Prescription" ? "Domestic" : "OK"}
        </Button>
      </div>
      <div style={{ display: "hidden", height: 0 }}>
        {isPrint &&
          userPrescription &&
          Object.keys(userPrescription).length && (
            <>
              <InternationalPrescription
                dataObj={userPrescription}
                setIsPrint={setIsPrint}
              />
            </>
          )}
      </div>
    </div>
  );
}

export default ConfirmationPrompt;
//
